export default {
  base_url: 'https://api.pandits.id/',
  // base_url: 'https://pandora-api.komunestudio.com/',
};
